import { faker } from "@faker-js/faker";
import { Factory } from "fishery";
import { PaymentRowItem } from "../components/PaymentBatchesTable/types";
import { PaymentMethod } from "../graphql/supergraphOperations";
import { toGlobalId } from "../utils/graphql_utils";
import { moneyFactory } from "./money.factory";
import { paymentTypeFactory } from "./paymentType.factory";

export const paymentRowFactory = Factory.define<PaymentRowItem>(({ sequence }) => {
  return {
    id: sequence.toString(),
    batchId: toGlobalId("PaymentBatchObjectType", sequence),
    distributionName: "sampleDistributionName",
    createdDate: "2024-12-06",
    batchStatusConfig: {
      label: "sample label",
      labelColor: "red",
    },
    paymentStatus: [{ label: "Sample payment status" }],
    paymentMethod: PaymentMethod.Ach,
    clientName: faker.company.name(),
    entityName: faker.company.name(),
    entityId: toGlobalId("AccountObjectType", sequence),
    originatingAccount: "originatingAccount",
    receivingAccount: "receivingAccount",
    totalAmount: moneyFactory.build(),
    payments: paymentTypeFactory.buildList(2),
    hostName: "sample host name",
    paymentDescription: "sample description",
    creatorID: "creator",
  };
});
